export const SPECIAL_AWARD_KEYS = ['best_in_show', 'grand_champion', 'reserve_grand'] as const

export type SpecialAwardKey = (typeof SPECIAL_AWARD_KEYS)[number]

export const SPECIAL_AWARD_LABELS: Record<SpecialAwardKey, string> = {
  best_in_show: 'Best in Show',
  grand_champion: 'Grand Champion',
  reserve_grand: 'Reserve Champion',
}

function titleizeFromKey(value: string): string {
  return value
    .split('_')
    .filter(Boolean)
    .map(part => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ')
}

export function getSpecialAwardLabel(type: string): string {
  if (type in SPECIAL_AWARD_LABELS) {
    return SPECIAL_AWARD_LABELS[type as SpecialAwardKey]
  }
  return titleizeFromKey(type)
}
